import { useImagePreload } from '../../hooks/useImagePreload';
import { LoadingThumbnail } from './LoadingThumbnail';
import { Thumbnail, ThumbnailProps } from './thumbnail';

interface Props extends ThumbnailProps {
  theme: 'dark' | 'light';
}

export function PreloadedThumbnail({ theme, ...rest }: Props) {
  const preloaded = useImagePreload(rest.url);

  if (!preloaded) {
    return (
      <LoadingThumbnail metadata={rest.metadata} theme={theme} targetHeight={rest.targetHeight} />
    );
  }

  return <Thumbnail {...rest} />;
}
